import { createFileRoute } from '@tanstack/react-router';
import { InvoicesRegister } from '../../../../features/sales-invoicing/InvoicesRegister';

/** Owned by G23. Invoices register. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/invoices/')({
  component: InvoicesRegister,
});
